import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ContenidoService } from '../../services/contenido.service';
import { map, catchError, switchMap } from 'rxjs/operators';
import { AppState } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { detalleCancelled, detalleEmergenciaRequested, detalleLoaded, detalleRequested } from "./detalle.actions";
import { ToastService } from "src/app/services/toast.service";


@Injectable()
export class DetalleEffects {

	loadContenidoDetalle$ = createEffect( () => this.actions$.pipe(
		ofType( detalleRequested ),
		switchMap( action => {
			return this.service.findContenidoDetalleByRid( action.contenidoRid ).pipe(
				map( detalle => detalleLoaded( { detalle } ) ),
				catchError( () => {
					this.toastService.danger( "No se pudo cargar el contenido" );
					return of( detalleCancelled() );
				})
			)
		})
	));

	loadEmergencia$ = createEffect( () => this.actions$.pipe(
		ofType( detalleEmergenciaRequested ),
		switchMap( () => {
			return this.service.findReporteEmergenciaDetalle().pipe(
				map( detalle => detalleLoaded( { detalle } ) ),
				catchError( () => {
					this.toastService.danger( "No se pudo obtener el reporte de emergencias" );
					return of( detalleCancelled() );
				})
			);
		})
	));

	constructor( private actions$: Actions, private store$: Store<AppState>, private service: ContenidoService, private toastService: ToastService ) {
	}

}